import { connect } from 'react-redux';
import LanguagePicker from './language-picker.jsx';
import { updateLocale } from '../../../app-dux/app-dux';

export default connect(
    //mapStateToProps
    ( state ) => {
        return {
            locales: state.app.locales,
            locale: state.app.locale,
            defaultLocale: state.company.defaultLocaleCode
        };
    },
    //mapDispatchToProps
    {
        updateLocale
    }
)( LanguagePicker );